import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Briefcase } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function StickyNav() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#F5F0EB]/90 backdrop-blur-md border-b border-neutral-200 py-3 shadow-sm' : 'bg-transparent py-5'}`} data-id="element-203">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center justify-between" data-id="element-204">
        <div className="flex items-center gap-2" data-id="element-205">
          <div className="bg-neutral-900 p-1.5 rounded text-white" data-id="element-206">
            <Briefcase size={20} data-id="element-207" />
          </div>
          <span className={`font-serif font-bold text-lg tracking-tight ${isScrolled ? 'text-neutral-900' : 'text-neutral-900'}`} data-id="element-208">
            Settle-In Anywhere
          </span>
        </div>

        <div className={`transition-opacity duration-300 ${isScrolled ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} data-id="element-209">
          <Button size="sm" onClick={() => {
          trackAddToCart();
          window.open('https://www.versastorex.com/cart/41995679793232:1', '_blank');
        }} data-id="element-210">
            Get the Kit
          </Button>
        </div>
      </div>
    </nav>;
}